<template>
  <div>
    <LTSHeader></LTSHeader>
    <div class="container">
      <div v-if="error" class="card">
        <div class="card-header bg-danger text-white text-bold text-center">{{ error }}</div>
      </div>
      <div class="header-section">
        <div class="text-bold">Administrator: Reports</div>
        <div class="back-btn">
          <router-link class="btn-sm bg-primary text-white text-bold" to="/links">
            <img src="../assets/arrow-left.svg" alt /> Back
          </router-link>
        </div>
      </div>
      <div class="filters-section">
        <div class="mb-1">
          <label for="reports">Report:</label>
          <select
            name="reports"
            v-model="selectedReport"
            id="reports"
            class="textbox ml-1"
            style="width: 400px !important;"
          >
            <option value="Users Logged into the Single Login">Users logged into the single login</option>
            <option value="Users logged into LTS Applications">Users logged into LTS Applications</option>
          </select>
        </div>
        <div>
          <label for="from" class="mr-1">From:</label>
          <input
            type="date"
            v-model="fromDate"
            id="from"
            name="from"
            class="textbox"
            style="width: 140px !important;"
          />
          <label for="to" class="mr-1 ml-1">To:</label>
          <input type="date" v-model="toDate" id="to" name="to" class="textbox" style="width: 140px !important;" />
        </div>
        <div class="generate-button">
          <button v-show="!isLoading" class="btn bg-primary text-white mr-2" @click.prevent="getReport">
            Generate and download
          </button>
        </div>
      </div>
      <Loader v-show="isLoading" class="loader"></Loader>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
  components: {
    LTSHeader,
    Loader
  },
  data: function() {
    return {
      isLoading: false,
      selectedReport: "",
      fromDate: "",
      toDate: "",
      error: ""
    };
  },
  methods: {
    getReport: function() {
      this.error = "";

      if (this.selectedReport.length == 0) {
        this.error = "Please select a report.";
        return;
      }

      if (this.fromDate.length == 0 || this.toDate.length == 0) {
        this.error = "Please select a from and to date.";
        return;
      }

      this.isLoading = true;

      var reportToLoad = "";

      if (this.selectedReport == "Users Logged into the Single Login") {
        reportToLoad = "userlogin";
      } else {
        reportToLoad = "userloginapps";
      }

      console.log(reportToLoad);

      axios
        .post(
          "/reports/" + reportToLoad,
          {
            fromDate: this.fromDate,
            toDate: this.toDate
          },
          { responseType: "blob" }
        )
        .then((response) => {
          saveAs(response.data, this.selectedReport + "_report.XLSX");
        })
        .catch(() => {
          this.error = "No Data.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.filters-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.generate-button {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin-bottom: 0 !important;
}

.loader {
  width: 4rem;
  margin: 0 auto;
}
</style>
